module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content",
    attrs: {
      "id": "settings-nav"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    staticClass: "bottom",
    attrs: {
      "width": "100",
      "tablet": "40",
      "desktop": "30"
    }
  }, [_c('div', {
    staticClass: "tabletDesktopOnly"
  }, [_c('mu-list', {
    staticClass: "routes"
  }, _vm._l((_vm.routes), function(route, index) {
    return (_vm.hideSettingsMenu(route.name)) ? _c('mu-list-item', {
      key: 'setting-route-' + index,
      attrs: {
        "to": route.route,
        "title": _vm.$t(route.i18n)
      }
    }, [_c('mu-icon', {
      staticClass: "left8",
      attrs: {
        "slot": "left",
        "value": route.icon
      },
      slot: "left"
    })], 1) : _vm._e()
  }), 1)], 1)]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "60",
      "desktop": "70"
    }
  }, [_c('mu-paper', {
    staticClass: "settings"
  }, [(_vm.$route.name !== 'SettingsEditMedications' && _vm.$route.name !== 'SettingsAddMedications') ? _c('mu-content-block', {
    staticClass: "mobileOnly",
    staticStyle: {
      "margin-bottom": "-28px"
    }
  }, [_c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100"
    }
  }, [_c('mu-select-field', {
    attrs: {
      "scroller": _vm.scroller,
      "fullWidth": ""
    },
    model: {
      value: (_vm.activeRoute),
      callback: function($$v) {
        _vm.activeRoute = $$v
      },
      expression: "activeRoute"
    }
  }, _vm._l((_vm.routes), function(route, index) {
    return (_vm.hideSettingsMenu(route.name)) ? _c('mu-menu-item', {
      key: 'setting-nav-' + index,
      attrs: {
        "title": _vm.$t(route.i18n),
        "value": route
      }
    }) : _vm._e()
  }), 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f9213fe","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Settings/Layout.vue
// module id = 3628
// module chunks = 1